const DAYS_BEFORE_MQ3 = 4
const DAYS_BEFORE_MQ1 = 1

export const getDaysBefore = (isSmallScreen: boolean) => {
  return -(isSmallScreen ? DAYS_BEFORE_MQ1 : DAYS_BEFORE_MQ3)
}
